import { defineAsyncComponent } from 'vue'
export default {
  lms: defineAsyncComponent(() => import("/Users/mauriciomateus/sites/ipa-lms/layouts/Lms.vue").then(m => m.default || m)),
  maintenance: defineAsyncComponent(() => import("/Users/mauriciomateus/sites/ipa-lms/layouts/Maintenance.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/Users/mauriciomateus/sites/ipa-lms/layouts/default.vue").then(m => m.default || m)),
  "all-ireland": defineAsyncComponent(() => import("/Users/mauriciomateus/sites/ipa-lms/brands/allireland/layouts/AllIreland.vue").then(m => m.default || m))
}